module.exports = __webpack_public_path__ + "static/media/service-bg.53da834c.png";